import { render } from "./HomePageV2.vue?vue&type=template&id=09dead68&scoped=true"
import script from "./HomePageV2.vue?vue&type=script&lang=js"
export * from "./HomePageV2.vue?vue&type=script&lang=js"

import "./HomePageV2.vue?vue&type=style&index=0&id=09dead68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09dead68"]])

export default __exports__